import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// 🛡️ Global fetch interceptor to automatically inject actor parameter to bypass CORS preflight
const originalFetch = window.fetch;
window.fetch = async function (url, options = {}) {
  let actor = 'System';
  try {
    const storedUser = localStorage.getItem('thunder_crm_user') || sessionStorage.getItem('thunder_crm_user');
    if (storedUser) {
      const user = JSON.parse(storedUser);
      if (user && user.name) {
        actor = user.name;
      }
    }
  } catch (e) {}

  // Append actor as a query parameter in the URL (to avoid triggering CORS Preflight options block)
  let newUrl = url.toString();
  const separator = newUrl.includes('?') ? '&' : '?';
  newUrl = `${newUrl}${separator}actor=${encodeURIComponent(actor)}`;
  
  return originalFetch(newUrl, options);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);